<template>
  <router-view />
</template>

<script lang="ts">
// Components
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'App',
})
</script>

<style scoped></style>
